<div
  id="sections"
  class="sections"
  [ngClass]="{
    'two-sections': section().nbSection === 2,
  }"
  [style.height.px]="height() - 3"
  [style.background-color]="
    hasTelework() ? teleworkService.teleworkColor : CommonUtils.color('white')
  "
  (mousemove)="onResize($event)"
  (mouseup)="stop($event)"
>
  @for (task of tasks(); track task.task.id) {
    <div
      class="task"
      [style]="task.style"
      [draggable]="canDrag() && task.task.enable"
      (dragstart)="onDragStart(task)"
      (dragover)="$event.preventDefault()"
      (dragend)="onDragEnd()"
    >
      <infl-task
        [task]="task.task"
        [canResize]="canResize() && this.section().nbSection === 2"
        (startResize)="startResize($event)"
        (taskClick)="onTaskClick($event)"
        (taskDblClick)="taskDblClick.emit($event)"
        (taskHover)="taskHover.emit($event)"
      ></infl-task>
    </div>
  }
  <div
    class="section1"
    (mousedown)="selectZone($event)"
    (mouseover)="overZone($event, 1)"
    (dragover)="lastSectionHighlighted.emit($event)"
    (drop)="onDrop(1)"
  ></div>
  @if (section().nbSection === 2) {
    <div
      class="section2"
      (mousedown)="selectZone($event)"
      (mouseover)="overZone($event, 2)"
      (dragover)="lastSectionHighlighted.emit($event)"
      (drop)="onDrop(2)"
    ></div>
  }
</div>
